import { render } from "./FormCheckbox.vue?vue&type=template&id=913cdd16"
import script from "./FormCheckbox.vue?vue&type=script&lang=js"
export * from "./FormCheckbox.vue?vue&type=script&lang=js"

import "./FormCheckbox.vue?vue&type=style&index=0&id=913cdd16&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__